<!-- src/views/About.vue -->
<!-- eslint-disable -->
<template>
  <div class="thingcontainer">

    <div>
      <button @click="toggleSearch" class="toggle-button">
        {{ isSearchVisible ? '▲' : '▼' }}
      </button>
      <transition name="slide">
        <div v-if="isSearchVisible" class="content-container">
          <div class="searchBox">
            <div class="filter-controls">
              <input v-model="filterUid" placeholder="Filter UID (partial)" class="filter-input" />
              <label>Days:</label>
              <input type="number" v-model="filterDays" class="filter-input" style="width: 60px;" />
              <label>End Date:</label>
              <input type="date" v-model="filterEndDate" class="filter-input" />
              <button @click="fetchData" class="refresh-btn">Fetch</button>
            </div>
            <div class="content">
              <div class="search-table">
                <PidEventCountTable />
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div class="horiz-container">
      <button @click="toggleEvents" class="toggle-button">
        {{ isEventsVisible ? '◀' : '▶' }}
      </button>
      <div v-show="isEventsVisible" class="resizable-panel" :style="{ width: panelWidth + 'px' }">
        <div class="eventpanel">
          <PidJourneyEventPanel />
        </div>
        <div v-if="dataStore.isEventsLoading" class="loading-overlay">
          <div class="spinner"></div>
          <div class="loading-text">Loading Events...</div>
        </div>
      </div>
      <div v-show="isEventsVisible" class="resize-handle" @mousedown="startResize"></div>
      <div class="events-map">
        <Map />
      </div>
    </div>

    <div v-if="dataStore.isLoading" class="loading-overlay">
      <div class="spinner"></div>
      <div class="loading-text">Loading Tracking Data...</div>
    </div>
  </div>
</template>


<script setup>
/* eslint-disable */
import PidEventCountTable from '../components/PIDEventCountTable.vue';
import PidJourneyEventPanel from '../components/PIDJourneyEventPanel.vue';
import Map from '../components/Map.vue';
import { createDataStore } from '@/statedata/pidtrackingdata';
import { ref, provide, onMounted } from 'vue';

const isSearchVisible = ref(true);
const isEventsVisible = ref(true);
const dataStore = createDataStore({ name: "PIDTracking", dbname: "CSVC_trial" });
provide('datastore', dataStore);

const filterUid = ref('');
const filterDays = ref(2);
const filterEndDate = ref(new Date().toISOString().substr(0, 10));

async function fetchData() {
  const endDate = new Date(filterEndDate.value);
  const startDate = new Date(endDate);
  startDate.setDate(endDate.getDate() - filterDays.value);

  await dataStore.fetchPidEventsDayCounts({
    uid: filterUid.value,
    startDate: startDate.toISOString().substr(0, 10),
    endDate: filterEndDate.value
  });
}

console.log(`Pid events fetch`)

onMounted(async () => {
  // Initial load removed as per user request
});

const toggleSearch = () => {
  isSearchVisible.value = !isSearchVisible.value;
};

const panelWidth = ref(550); // Default width (increased by 20%)
const isResizing = ref(false);
const startX = ref(0);
const startWidth = ref(0);

const startResize = (e) => {
  isResizing.value = true;
  startX.value = e.clientX;
  startWidth.value = panelWidth.value;
  document.addEventListener('mousemove', onResize);
  document.addEventListener('mouseup', stopResize);
  document.body.style.cursor = 'col-resize';
  document.body.style.userSelect = 'none'; // Prevent selection while dragging
};

const onResize = (e) => {
  if (!isResizing.value) return;
  const delta = e.clientX - startX.value;
  let newWidth = startWidth.value + delta;

  if (newWidth < 200) newWidth = 200;
  if (newWidth > window.innerWidth * 0.8) newWidth = window.innerWidth * 0.8;
  panelWidth.value = newWidth;
};

const stopResize = () => {
  isResizing.value = false;
  document.removeEventListener('mousemove', onResize);
  document.removeEventListener('mouseup', stopResize);
  document.body.style.cursor = '';
  document.body.style.userSelect = '';
  // Force map resize
  if (dataStore.map) {
    dataStore.map.invalidateSize();
  }
};

const toggleEvents = () => {
  isEventsVisible.value = !isEventsVisible.value;
  // Map needs to resize after the DOM updates
  setTimeout(() => {
    if (dataStore.map) {
      dataStore.map.invalidateSize();
    }
  }, 1000); // Wait for transition / reflow
};

</script>

<style></style>

<style scoped>
.thingcontainer {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  height: 100%;
  position: relative;
}

.horiz-container {
  display: flex;
  flex-direction: row;

  border: 2px solid #367530;
  padding: 0px, 0px;
  gap: 0px;
  width: 100%;
  height: 100%;
  min-height: 100px;
  box-sizing: border-box;
}

.eventpanel {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.searchBox {
  display: flex;
  flex-direction: row;
}

.content {
  display: flex;
  flex-direction: column;
  flex: 2;
}

.search-table {
  max-height: 150px;
  overflow-y: auto;
}

.working-table {
  max-height: 150px;
  overflow-y: auto;
}

.events-map {
  flex: 1;
  /* Take remaining space */
  width: auto;
  height: 100%;
  min-width: 0;
  /* Allow shrinking below content size if needed */
}

.btn-off {
  background-color: #ccc;
}

.btn-on {
  background-color: #4caf50;
}

.content-container {
  overflow: hidden;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
}

.slide-enter-to,
.slide-leave-from {
  max-height: 500px;
  /* Set this to a value large enough to fit your content */
  /* Set this to a value large enough to fit your content */
  opacity: 1;
}

.resizable-panel {
  flex-shrink: 0;
  /* Prevent it from shrinking */
  height: 100%;
  border-right: 1px solid #ccc;
  text-align: left;
  display: flex;
  flex-direction: column;
  position: relative;
}

.resize-handle {
  width: 5px;
  height: 100%;
  background-color: #f0f0f0;
  cursor: col-resize;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.resize-handle:hover,
.resize-handle:active {
  background-color: #ccc;
}

.toggle-button {
  flex: 0 0 auto;
  width: auto;
  cursor: pointer;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(2px);
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

.loading-text {
  margin-top: 15px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.filter-controls {
  display: flex;
  gap: 10px;
  padding: 10px;
  background: #f0f0f0;
  border-bottom: 1px solid #ddd;
  align-items: center;
}

.filter-input {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.refresh-btn {
  padding: 5px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.refresh-btn:hover {
  background-color: #0056b3;
}
</style>
